let notificationCallback = null;

export const setNotificationCallback = (callback) => {
  notificationCallback = callback;
};

export const showNotification = (message, type = 'info', duration = 10000) => {
  if (notificationCallback) {
    notificationCallback(message, type, duration);
  } else {
    // Fallback to alert if notification system not initialized
    console.warn('Notification system not initialized');
    alert(message);
  }
};

// Convenience methods
export const showSuccess = (message, duration = 5000) => showNotification(message, 'success', duration);
export const showError = (message, duration = 5000) => showNotification(message, 'error', duration);
export const showWarning = (message, duration = 5000) => showNotification(message, 'warning', duration);
export const showInfo = (message, duration = 5000) => showNotification(message, 'info', duration);
